export const putConfig = {
    method: 'PUT',
    paths: ['/api/orgs/:orgId/locations/:locationId/kiosks/:kioskId/config'],
    fields: {
        printerMacAddress: {
            type: 'keyString',
        },
        paymentTerminalSerialNumber: {
            type: 'keyString',
        },
        paymentTerminalIpAddress: {
            type: 'keyString',
        },
        hasScanner: {
            type: 'bool',
        },
        hasScale: {
            type: 'bool',
        },
        hasHid: {
            type: 'bool',
        },
        hasMsr: {
            type: 'bool',
        },
        hasStormAudioNav: {
            type: 'bool',
        },
        isPrinterConfigured: {
            type: 'bool',
        },
        isScannerConfigured: {
            type: 'bool',
        },
        isHidConfigured: {
            type: 'bool',
        },
        isMsrConfigured: {
            type: 'bool',
        },
        isScaleConfigured: {
            type: 'bool',
        },
        isStormAudioNavConfigured: {
            type: 'bool',
        },
    },
    // the request will only respect changes to peripherals
};
//# sourceMappingURL=kiosk_put_config.js.map